import ReactDOM from 'react-dom';
import { App } from './containers/App';

const app = document.getElementById('app');
ReactDOM.render(<App />, app);
